module.exports = __webpack_public_path__ + "img/gartek-portfolio-healthcare.695f9ef0.jpeg";